import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import {
  Form, Input, Select, Icon, Button,
} from 'semantic-ui-react';
import { EMAIL_FREQUENCY_OPTIONS } from '../../constants';

const NotificationSettingsRow = ({
  notificationSetting,
  onChangeEmailFrequencyHandler,
  removeNotificationSettingHandler,
}) => {
  return (
    <Form.Group widths='equal' key={notificationSetting.id}>
      <Form.Field required>
        <label htmlFor={`dealerNumber-${notificationSetting.id}`}>Dealer Number</label>
        <Input id={`dealerNumber-${notificationSetting.id}`} value={notificationSetting.dealerNumber} />
      </Form.Field>
      <Form.Field required>
        <label htmlFor={`emailFrequency-${notificationSetting.id}`}>Email frequency</label>
        <Select
          id={`emailFrequency-${notificationSetting.id}`}
          placeholder='Select frequency'
          options={EMAIL_FREQUENCY_OPTIONS}
          onChange={onChangeEmailFrequencyHandler(
            notificationSetting.dealerNumber
          )}
          value={notificationSetting.emailFrequency}
          className='email-frequency-selector'
        />
        {isEmpty(notificationSetting.id) && (
          <Button
            icon
            size='mini'
            color='red'
            content={notificationSetting.dealerNumber}
            onClick={removeNotificationSettingHandler(
              notificationSetting.dealerNumber
            )}
          >
            <Icon name='remove' />
          </Button>
        )}
      </Form.Field>
    </Form.Group>
  );
};

NotificationSettingsRow.propTypes = {
  notificationSetting: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dealerNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    emailFrequency: PropTypes.string,
  }).isRequired,
  onChangeEmailFrequencyHandler: PropTypes.func.isRequired,
  removeNotificationSettingHandler: PropTypes.func.isRequired,
};

export default NotificationSettingsRow;
